export const GET_SEND_QUERY_ROUTE = (
  intent,
  userQuery,
  filteredQuery,
  timestamp,
  uid,
  deity
) =>
  `https://us-central1-dev-divinator.cloudfunctions.net/sendQueryToFirebase?intent=${intent}&userQuery=${userQuery}&filteredQuery=${filteredQuery}&timestamp=${timestamp}&uid=${uid}&deity=${deity}`;
